import Container from 'react-bootstrap/Container'
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Logo from '../img/logo2.png'
import {useAuth} from "../../services/auth"


export default function Logout(handleClick) {

    const {LogOut} = useAuth()


    return (
        <div style={{ backgroundColor: "#1565c0", height: "100vh" }}>
            <Container fluid="sm" style={{ width: "30%", top: "15rem", position: "relative" }} >
                    <Paper elevation={6} style={{ height: "20rem", minWidth:'33rem' }}>
                        <div style={{ left: '30%', position: 'relative' }}>
                            <FormControl sx={{ m: 2, width: '25ch' }} variant="outlined">
                                <div style={{ marginBottom: "2rem" }}>
                                    <img src={Logo} alt="logo-birmind" style={{ maxWidth: "20rem", marginLeft: "1rem" }} />
                                </div>
                                <span>Deseja deslogar do gerenciador de licenças?</span>
                            </FormControl>
                            <FormControl sx={{ m: 2, width: '25ch' }} variant="outlined">
                                <Button
                                    onClick={LogOut} type="submit" variant="contained" style={{ top: '9rem', right: '16rem', position: 'relative' }}>
                                    Sair
                                </Button>
                            </FormControl>
                        </div>
                    </Paper>
            </Container>
        </div >
    )
}